/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';

import { useInject } from '@vk-hr-tek/core/ioc';

import { useDispatch } from '../../../../app/hooks';
import { PageLoading } from '../../../../layout';
import { useAuth } from '../../../hooks';
import { verifyOAuth2Code } from '../../../slice';
import { AuthRouterService } from '../../../services';

export const VerifyAuthCode = () => {
  const dispatch = useDispatch();
  const isAuthenticated = useAuth();
  const router = useInject(AuthRouterService);

  useEffect(() => {
    if (isAuthenticated) {
      router.redirectToSaved();
    }
  }, [isAuthenticated, router]);

  useEffect(() => {
    if (!isAuthenticated) {
      dispatch(verifyOAuth2Code());
    }
  }, [isAuthenticated, dispatch]);

  return <PageLoading />;
};
